export default {
  android: 'https://play.google.com/store/apps/details?id=net.intellectsoft.experian',
  ios: 'https://apps.apple.com/app/apple-store/id1114748256',
};
